// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { CheckCircle2, ChevronDown, ChevronUp, X, Mail, AlertTriangle, Search } from "lucide-react"; 
// import { toast } from "react-toastify";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import { useNavigate, useParams } from "react-router-dom";
// import PageHeader from "../ui/PageHeader";
// import CustomDatePicker from "../../customStyles/CustomDatePicker"; 
// import { formatDateTime } from "../../helpers/formatDateTime";

// export default function TagKra() {
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false); 
//   const [successData, setSuccessData] = useState(null); 
//   const [showConfirmModal, setShowConfirmModal] = useState(false); 
//   const navigate = useNavigate();
//   const { portalName } = useParams();

//   // Dependency lists from backend
//   const [usersList, setUsersList] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [bundlesList, setBundlesList] = useState([]);
//   const [templatesList, setTemplatesList] = useState([]);
//   const [workflowsList, setWorkflowsList] = useState([]);

//   // Filters & Workspace selection states
//   const [filterBy, setFilterBy] = useState("employee"); 
//   const [selectedDesignation, setSelectedDesignation] = useState("");
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [activeSourceTab, setActiveSourceTab] = useState("bundles"); 

//   // Master lists search states
//   const [bundleSearchTerm, setBundleSearchTerm] = useState("");
//   const [templateSearchTerm, setTemplateSearchTerm] = useState("");

//   // Current active selections in Workspace
//   const [selectedEmployees, setSelectedEmployees] = useState([]); 
//   const [selectedBundleId, setSelectedBundleId] = useState(""); 
//   const [selectedKras, setSelectedKras] = useState([]); 

//   // Allocation Meta Parameters
//   const [year, setYear] = useState(2026);
//   const [startDate, setStartDate] = useState("2026-04-01");
//   const [endDate, setEndDate] = useState("2027-03-31");
//   const [reviewCycle, setReviewCycle] = useState("3_MONTHS"); 
//   const [workflowId, setWorkflowId] = useState("");

//   const [expandedCardId, setExpandedCardId] = useState(null); 

//   const loadWorkspaceDependencies = useCallback(async () => {
//     setLoading(true);
//     try {
//       const [usersRes, deptRes, desRes, bundlesRes, templatesRes, workflowsRes] = await Promise.all([
//         api.get(SummaryApi.getAllUsers.url),
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllDesignations?.url || "/api/hr/designations"),
//         api.get(SummaryApi.getAllKraBundles?.url || "/api/hr/kras/bundles"),
//         api.get(SummaryApi.getAllKraTemplates?.url || "/api/hr/kras/templates"),
//         api.get(SummaryApi.getAllKRAReviewWorkflows?.url || "/api/hr/performance/workflows")
//       ]);

//       if (usersRes.data.success) setUsersList(usersRes.data.data || []);
//       if (deptRes.data.success) setDepartments(deptRes.data.data || []);
//       if (desRes.data.success) setDesignations(desRes.data.data || []);
//       if (bundlesRes.data.success) setBundlesList(bundlesRes.data.data || []);
//       if (templatesRes.data.success) setTemplatesList(templatesRes.data.data || []);
//       if (workflowsRes.data.success) setWorkflowsList(workflowsRes.data.data || []);
//     } catch {
//       toast.error("Failed to load dependency data for goal tagging.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadWorkspaceDependencies();
//   }, [loadWorkspaceDependencies]);

//   // Object / String ID முரண்பாடுகளைச் சரிசெய்யும் பாதுகாப்புச் சார்பு (Safe comparison helper)
//   const getCleanId = (field) => {
//     if (!field) return "";
//     return typeof field === "object" ? (field._id || "").toString() : field.toString();
//   };

//   // Designation அல்லது Department மாறும் போது ஊழியர்களை துல்லியமாகத் தேர்ந்தெடுக்கும் ஹூக்
//   useEffect(() => {
//     if (filterBy === "designation") {
//       if (!selectedDesignation && !selectedDepartment) {
//         setSelectedEmployees([]);
//         return;
//       }

//       const matchedUsers = usersList.filter(u => {
//         const uDesigId = getCleanId(u.designationId);
//         const uDeptId = getCleanId(u.departmentId);

//         const matchDesig = selectedDesignation ? (uDesigId === selectedDesignation) : true;
//         const matchDept = selectedDepartment ? (uDeptId === selectedDepartment) : true;

//         return matchDesig && matchDept && u.isActive !== false;
//       });

//       setSelectedEmployees(matchedUsers);
//     }
//   }, [filterBy, selectedDesignation, selectedDepartment, usersList]);

//   // Dropdown options formatting
//   const designationOptions = useMemo(() => designations.map(d => ({ label: d.title, value: d._id })), [designations]);
//   const departmentOptions = useMemo(() => departments.map(d => ({ label: d.name, value: d._id })), [departments]);
//   const workflowOptions = useMemo(() => workflowsList.map(w => ({ label: w.name, value: w._id })), [workflowsList]);
//   const employeeDropdownOptions = useMemo(() => {
//     return usersList
//       .filter(u => u.isActive !== false)
//       .map(u => ({ label: `${u.firstName} ${u.lastName} - ${u.userId}`, value: u._id, raw: u }));
//   }, [usersList]);

//   const filteredBundles = useMemo(() => {
//     return bundlesList.filter(b => {
//       const query = bundleSearchTerm.toLowerCase();
//       return (
//         b.name?.toLowerCase().includes(query) ||
//         b.description?.toLowerCase().includes(query) ||
//         b.year?.toString().includes(query)
//       );
//     });
//   }, [bundlesList, bundleSearchTerm]);

//   const filteredTemplates = useMemo(() => {
//     return templatesList.filter(t => {
//       const query = templateSearchTerm.toLowerCase();
//       return (
//         t.name?.toLowerCase().includes(query) ||
//         t.description?.toLowerCase().includes(query) ||
//         t.category?.toLowerCase().includes(query)
//       );
//     });
//   }, [templatesList, templateSearchTerm]);

//   const handleSelectEmployeeDirect = (empId) => {
//     const matchedUser = usersList.find(u => u._id === empId);
//     if (matchedUser && !selectedEmployees.some(e => e._id === empId)) {
//       setSelectedEmployees(prev => [...prev, matchedUser]);
//     }
//   };

//   const handleRemoveEmployee = (empId) => {
//     setSelectedEmployees(prev => prev.filter(e => e._id !== empId));
//   };

//     // Handle designation selection: Auto-populate employee list under that designation
//   const handleDesignationSelect = (desigId) => {
//     setSelectedDesignation(desigId);
//     if (!desigId) {
//       setSelectedEmployees([]);
//       return;
//     }
//     const matchedUsers = usersList.filter(u => u.designationId?._id === desigId && u.isActive !== false);
//     setSelectedEmployees(matchedUsers);
//   };

//   const handleSelectBundle = (bundle) => {
//     setSelectedBundleId(bundle._id);
//     setReviewCycle(bundle.reviewCycle); 
//     const mapped = bundle.kras?.map(k => ({
//       kraId: k.kraId?._id || k.kraId,
//       name: k.kraId?.name || k.name || "Goal Metric",
//       description: k.kraId?.description || k.description || "",
//       category: k.kraId?.category || k.category || "Technical",
//       weightage: k.weightage || 0,
//       reviewCycle: k.reviewCycle || bundle.reviewCycle || "3_MONTHS",
//       monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",
//       yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || ""
//     })) || [];
//     setSelectedKras(mapped);
//     toast.success(`${bundle.name} details imported into assignment workspace.`);
//   };

//   const handleAddCustomKra = (template) => {
//     if (selectedKras.some(k => k.kraId === template._id)) return;
//     setSelectedKras(prev => [
//       ...prev,
//       {
//         kraId: template._id,
//         name: template.name,
//         description: template.description,
//         category: template.category || "Technical",
//         weightage: 0,
//         reviewCycle: template.reviewCycle || reviewCycle || "3_MONTHS",
//         monthlyTarget: template.monthlyTarget || "",
//         yearlyTarget: template.yearlyTarget || ""
//       }
//     ]);
//   };

//   const handleRemoveCustomKra = (kraId) => {
//     setSelectedKras(prev => prev.filter(k => k.kraId !== kraId));
//   };

//   const handleItemChange = (index, key, val) => {
//     const updated = selectedKras.map((k, idx) => 
//       idx === index ? { ...k, [key]: val } : k
//     );
//     setSelectedKras(updated);
//   };

//   const handleAutoSplitWeights = () => {
//     const totalKras = selectedKras.length;
//     if (totalKras === 0) return;

//     const baseWeight = Math.floor(100 / totalKras);
//     const remainder = 100 % totalKras;

//     const updated = selectedKras.map((k, idx) => {
//       const weight = idx < remainder ? baseWeight + 1 : baseWeight;
//       return { ...k, weightage: weight };
//     });

//     setSelectedKras(updated);
//     toast.info("Weights distributed equally across all allocated KRA mappings.");
//   };

//   const totalCalculatedWeight = useMemo(() => {
//     return selectedKras.reduce((sum, k) => sum + Number(k.weightage), 0);
//   }, [selectedKras]);

//   const handleConfirmAllocationTrigger = () => {
//     if (selectedEmployees.length === 0) return toast.error("Please select at least one employee.");
//     if (!startDate || !endDate) return toast.error("Goal timeline boundary dates are required.");
//     if (!workflowId) return toast.error("Please assign a review process workflow.");
//     if (selectedKras.length === 0) return toast.error("Please add at least one KRA to allocate.");

//     if (totalCalculatedWeight !== 100) {
//       return toast.error(`Total assigned weightage must sum up to exactly 100%. Current total: ${totalCalculatedWeight}%.`);
//     }

//     setShowConfirmModal(true); 
//   };

//   const handleFinalSubmit = async () => {
//     setShowConfirmModal(false);
//     setSubmitting(true);

//     const payload = {
//       userIds: selectedEmployees.map(e => e._id),
//       year,
//       startDate: new Date(startDate).toISOString(),
//       endDate: new Date(endDate).toISOString(),
//       workflowId,
//       reviewCycle, 
//       bundleId: selectedBundleId || undefined,
//       krasInput: selectedKras.map(k => ({
//         kraId: k.kraId,
//         weightage: k.weightage,
//         reviewCycle: k.reviewCycle,
//         monthlyTarget: k.monthlyTarget || undefined,
//         yearlyTarget: k.yearlyTarget || undefined
//       }))
//     };

//     try {
//       const res = await api.post(SummaryApi.assignKra?.url || "/api/hr/kra/assign", payload);
//       if (res.data.success) {
//         setSuccessData(res.data.data); 
//         toast.success("Goals successfully allocated!");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to process goal allocation.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleResetWorkspace = () => {
//     setSelectedEmployees([]);
//     setSelectedBundleId("");
//     setSelectedKras([]);
//     setSuccessData(null);
//   };

//   const getDynamicUserDetails = useMemo(() => {
//     if (!successData || successData.length === 0) return { departments: "N/A", designations: "N/A" };
    
//     const matchedDepts = [];
//     const matchedDesigs = [];

//     successData.forEach(assign => {
//       const fullUser = usersList.find(u => u._id === (assign.userId?._id || assign.userId));
//       if (fullUser) {
//         const dept = fullUser.departmentId?.name || "N/A";
//         const desig = fullUser.designationId?.title || fullUser.designationId?.name || "N/A";
//         if (!matchedDepts.includes(dept)) matchedDepts.push(dept);
//         if (!matchedDesigs.includes(desig)) matchedDesigs.push(desig);
//       }
//     });

//     return {
//       departments: matchedDepts.join(", ") || "N/A",
//       designations: matchedDesigs.join(", ") || "N/A"
//     };
//   }, [successData, usersList]);

//   if (loading) return <PageLoader />;

//   // DYNAMIC SUCCESS SUMMARY VIEW
//   if (successData && successData.length > 0) {
//     const firstItem = successData[0];
//     const employeeNames = successData.map(item => {
//       const fullUser = usersList.find(u => u._id === (item.userId?._id || item.userId));
//       return fullUser ? `${fullUser.firstName} ${fullUser.lastName}` : "Employee";
//     }).join(", ");
    
//     const allocatedBy = firstItem.assignedBy ? `${firstItem.assignedBy.firstName} ${firstItem.assignedBy.lastName}` : "Sarah Jenkins (HRM)";
//     const allocationDate = firstItem.createdAt ? new Date(firstItem.createdAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : new Date().toLocaleDateString();

//     return (
//       <div className="space-y-6 animate-scale-in p-2">
//         <div className="text-center space-y-3">
//           <div className="w-16 h-16 bg-blue-50 border-2 border-blue-200 rounded-full flex items-center justify-center mx-auto text-blue-600">
//             <CheckCircle2 className="w-8 h-8" />
//           </div>
//           <h2 className="text-xl font-bold text-gray-900 leading-tight">KRA Successfully Allocated</h2>
//           <p className="text-xs text-gray-400 max-w-lg mx-auto">
//             The Key Result Areas have been successfully assigned to the employee(s) for the current review cycle. Notifications have been sent.
//           </p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           <div className="md:col-span-2 space-y-6">
//             <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
//               <div className="flex justify-between border-b pb-2">
//                 <span className="font-bold text-gray-800 text-sm">Allocation Summary</span>
//                 <span className="text-[10px] bg-green-50 text-green-700 font-bold px-2 py-0.5 rounded-full uppercase border border-green-200">Active Cycle</span>
//               </div>
              
//               <div className="grid grid-cols-2 gap-y-4 gap-x-2 text-xs">
//                 <div>
//                   <p className="text-gray-400 font-medium">Employee(s)</p>
//                   <p className="font-bold text-gray-900 mt-1">{employeeNames}</p>
//                 </div>
//                 <div>
//                   <p className="text-gray-400 font-medium">Department(s)</p>
//                   <p className="font-bold text-gray-900 mt-1">{getDynamicUserDetails.departments}</p>
//                 </div>
//                 <div>
//                   <p className="text-gray-400 font-medium">Designation(s)</p>
//                   <p className="font-bold text-gray-900 mt-1">{getDynamicUserDetails.designations}</p>
//                 </div>
//                 <div>
//                   <p className="text-gray-400 font-medium">Review Frequency & Workflow</p>
//                   <p className="font-bold text-gray-900 mt-1 truncate max-w-xs" title={firstItem.workflowId?.name}>
//                     {firstItem.workflowId?.name || "Standard Workflow"} ({firstItem.reviewCycle?.replace("_", " ")})
//                   </p>
//                 </div>
//                 <div>
//                   <p className="text-gray-400 font-medium">Allocation Date</p>
//                   <p className="font-bold text-gray-900 mt-1">{allocationDate}</p>
//                 </div>
//                 <div>
//                   <p className="text-gray-400 font-medium">Allocated By</p>
//                   <p className="font-bold text-gray-900 mt-1">{allocatedBy}</p>
//                 </div>
//               </div>
//             </div>

//             {/* Dynamic KRA List Visualizer */}
//             <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
//               <span className="font-bold text-gray-800 text-sm border-b pb-2 block">Assigned Goals ({firstItem.kras?.length || 0} items)</span>
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-[350px] overflow-y-auto pr-1">
//                 {firstItem.kras?.map((kra, index) => (
//                   <div key={index} className="p-3 bg-gray-50 border rounded-lg space-y-1">
//                     <div className="flex justify-between items-start gap-2">
//                       <span className="text-xs font-bold text-gray-800 truncate" title={kra.name}>{kra.name}</span>
//                       <span className="text-[9px] bg-red-100 text-red-600 font-bold px-1.5 py-0.5 rounded uppercase shrink-0">{kra.category}</span>
//                     </div>
//                     <p className="text-[10px] text-gray-400 line-clamp-2 leading-relaxed">{kra.description || "No description provided."}</p>
//                     <div className="pt-1 flex justify-between items-center text-[10px]">
//                       <span className="text-gray-400">Weightage</span>
//                       <span className="font-bold text-primary">{kra.weightage}%</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="space-y-6">
//             <div className="bg-white border rounded-lg p-6 space-y-3 shadow-sm flex flex-col">
//               <button onClick={handleResetWorkspace} className="w-full bg-primary hover:bg-secondary text-white py-3 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all">
//                 Allocate Another
//               </button>
//               <button onClick={() => navigate(`/${portalName}/hr/performance-management?tab=tag_kra_list`)} className="w-full bg-white border border-gray-200 text-gray-600 hover:bg-gray-100 py-3 rounded-lg font-bold text-xs uppercase transition-all">
//                 Go to Dashboard
//               </button>
//             </div>

//             <div className="bg-white border rounded-lg p-6 shadow-sm space-y-4">
//               <div className="flex items-center gap-2 text-xs font-bold text-gray-700">
//                 <Mail className="w-4 h-4 text-gray-400" />
//                 <span>Notification Sent Preview</span>
//               </div>
//               <div className="bg-gray-50 border p-4 rounded-xl text-[11px] space-y-2">
//                 <p className="font-bold text-gray-800">To: <span className="text-gray-500 font-normal">{firstItem.userId?.email || "Employee"}</span></p>
//                 <p className="font-bold text-gray-800">Subject: New KRA Assigned - FY {firstItem.year}</p>
//                 <p className="text-gray-500 leading-relaxed">
//                   Goals and Key Result Areas for the year {firstItem.year} have been successfully assigned. Please log in to your performance portal to acknowledge and accept them.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//     <div className="space-y-6 animate-in fade-in duration-300">
//       <PageHeader
//         title="Tag KRA"
//         description=""
//         isSticky={true}
//         topOffset="top-[51px]"
//         onBack={() => navigate(-1)}
//       />

//       {/* Modern Filter Board Structure (Optimized Border & Soft Shadow Layout) */}
//       <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] space-y-5">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
//           <div>
//             <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Filter By *</span>
//             <div className="flex items-center gap-6 h-10">
//               <label className="flex items-center gap-2.5 text-xs font-bold text-gray-700 cursor-pointer">
//                 <input 
//                   type="radio" 
//                   checked={filterBy === "designation"}
//                   onChange={() => { setFilterBy("designation"); handleDesignationSelect(""); }}
//                   className="accent-primary h-4 w-4"
//                 />
//                 Designation
//               </label>
//               <label className="flex items-center gap-2.5 text-xs font-bold text-gray-700 cursor-pointer">
//                 <input 
//                   type="radio" 
//                   checked={filterBy === "employee"}
//                   onChange={() => { setFilterBy("employee"); setSelectedEmployees([]); }}
//                   className="accent-primary h-4 w-4"
//                 />
//                 Employee
//               </label>
//             </div>
//           </div>

//           {filterBy === "designation" ? (
//             <div>
//               <label className="block text-xs font-extrabold text-gray-500 uppercase tracking-wider mb-1.5">Designation *</label>
//               <SelectDropdown 
//                 options={designationOptions}
//                 value={selectedDesignation}
//                 onChange={handleDesignationSelect}
//                 placeholder="Choose Designation..."
//                 valueKey="value"
//                 labelKey="label"
//                 searchable={true} 
//                 ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm"
//               />
//             </div>
//           ) : (
//             <div>
//               <label className="block text-xs font-extrabold text-gray-500 uppercase tracking-wider mb-1.5">Select Employee *</label>
//               <SelectDropdown 
//                 options={employeeDropdownOptions}
//                 onChange={handleSelectEmployeeDirect}
//                 placeholder="Search & choose employee..."
//                 searchable={true} 
//                 valueKey="value"
//                 labelKey="label"
//                 ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm"
//               />
//             </div>
//           )}

//           <div>
//             <label className="block text-xs font-extrabold text-gray-500 uppercase tracking-wider mb-1.5">Department</label>
//             <SelectDropdown options={departmentOptions} value={selectedDepartment} onChange={setSelectedDepartment} placeholder="All Departments" valueKey="value" labelKey="label" searchable={true} ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm" />
//           </div>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 pt-2">
//           <div>
//             <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Goal Start Date *</label>
//             <CustomDatePicker 
//               value={startDate} 
//               onChange={setStartDate} 
//               showCapacityInfo={false} 
//               inputClassName="h-10 text-sm rounded-lg border-gray-200 focus:border-red-400 shadow-sm"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Goal End Date *</label>
//             <CustomDatePicker 
//               value={endDate} 
//               onChange={setEndDate} 
//               showCapacityInfo={false} 
//               inputClassName="h-10 text-sm rounded-lg border-gray-200 focus:border-red-400 shadow-sm"
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Goal Target Year *</label>
//             <input type="number" value={year} onChange={(e) => setYear(Number(e.target.value) || 2026)} className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm h-10 outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 shadow-sm transition-all" />
//           </div>
//           <div>
//             <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Appraisal Workflow *</label>
//             <SelectDropdown options={workflowOptions} value={workflowId} onChange={setWorkflowId} placeholder="Select Workflow" valueKey="value" labelKey="label" searchable={true} ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm" />
//           </div>
//         </div>
//       </div>

//       {/* WORKSPACE SPLIT GRID LAYOUT */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
//         {/* LEFT PANEL */}
//         <div className="lg:col-span-2 space-y-4">
//           <div className="flex gap-4 border-b pb-2">
//             <button 
//               onClick={() => setActiveSourceTab("bundles")}
//               className={`pb-2 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
//                 activeSourceTab === "bundles" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"
//               }`}
//             >
//               Bundles ({filteredBundles.length})
//             </button>
//             <button 
//               onClick={() => setActiveSourceTab("individual")}
//               className={`pb-2 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
//                 activeSourceTab === "individual" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"
//               }`}
//             >
//               Individual KRAs ({filteredTemplates.length})
//             </button>
//           </div>

//           {/* Tab content search bars with Modernized Styles */}
//           {activeSourceTab === "bundles" ? (
//             <div className="relative">
//               <Search className="absolute left-3.5 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//               <input 
//                 type="text" 
//                 placeholder="Search KRA bundles..." 
//                 value={bundleSearchTerm} 
//                 onChange={(e) => setBundleSearchTerm(e.target.value)} 
//                 className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg outline-none text-xs focus:border-red-400 focus:ring-1 focus:ring-red-100 shadow-sm transition-all bg-white"
//               />
//             </div>
//           ) : (
//             <div className="relative">
//               <Search className="absolute left-3.5 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//               <input 
//                 type="text" 
//                 placeholder="Search individual templates..." 
//                 value={templateSearchTerm} 
//                 onChange={(e) => setTemplateSearchTerm(e.target.value)} 
//                 className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg outline-none text-xs focus:border-red-400 focus:ring-1 focus:ring-red-100 shadow-sm transition-all bg-white"
//               />
//             </div>
//           )}

//           <div className="space-y-4">
//             {activeSourceTab === "bundles" ? (
//               filteredBundles.map((bundle) => {
//                 const isExpanded = expandedCardId === bundle._id;
//                 const totalBundleWeight = bundle.kras?.reduce((sum, item) => sum + (item.weightage || 0), 0) || 0;
                
//                 const deptName = bundle.departmentId?.name;
//                 const desigTitle = bundle.designationId?.title || bundle.designationId?.name;
//                 const divName = bundle.divisionId?.name;
//                 const orgMeta = [divName, deptName, desigTitle].filter(Boolean).join(" • ");
//                 const isBundleActive = bundle.status === "ACTIVE";

//                 return (
//                   <div 
//                     key={bundle._id} 
//                     className={`bg-white border rounded-xl p-5 hover:shadow-md hover:border-primary transition-all duration-300 space-y-4 ${
//                       isExpanded ? "border-2 border-secondary hover:border-primary" : "border-gray-200"
//                     }`}
//                   >
//                     <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
//                       <div className="space-y-1.5 min-w-0 flex-1 text-left">
//                         <div className="flex flex-wrap items-center gap-2">
//                           <span className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
//                             {bundle.name}
//                           </span>
                          
//                           <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${
//                             bundle.status === "ACTIVE" 
//                               ? "bg-green-50 text-green-700 border border-green-200" 
//                               : "bg-gray-100 text-gray-500 border border-gray-200"
//                           }`}>
//                             {bundle.status}
//                           </span>

//                           <span className="text-[9px] bg-slate-50 text-slate-600 font-bold px-2 py-0.5 rounded-full border border-slate-200 uppercase tracking-wider">
//                             FY {bundle.year}
//                           </span>

//                           <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider border ${
//                             totalBundleWeight === 100
//                               ? "bg-blue-50 text-blue-700 border-blue-200"
//                               : "bg-amber-50 text-amber-700 border-amber-200"
//                           }`}>
//                             Weight: {totalBundleWeight}%
//                           </span>
//                         </div>

//                         {orgMeta && (
//                           <p className="text-[10px] text-primary font-bold uppercase tracking-wide">
//                             {orgMeta}
//                           </p>
//                         )}

//                         <p className="text-[10px] text-gray-400 font-medium">
//                           Contains {bundle.kras?.length || 0} goals | Created on {formatDateTime ? formatDateTime(bundle.createdAt, false) : new Date(bundle.createdAt).toLocaleDateString()}
//                         </p>
//                       </div>

//                       <div className="flex items-center gap-3 shrink-0 self-end md:self-center w-full md:w-auto justify-between md:justify-end border-t md:border-t-0 pt-3 md:pt-0">
//                         <span className="md:hidden text-[10px] text-gray-400 font-bold uppercase tracking-wider">
//                           Review Frequency: {bundle.reviewCycle?.replace("_", " ")}
//                         </span>
                        
//                         <div className="flex items-center gap-2">
//                           <button 
//                             disabled={!isBundleActive} 
//                             onClick={() => isBundleActive && handleSelectBundle(bundle)}
//                             className={`
//                               text-xs font-bold px-4 py-2 rounded-lg transition-all
//                               ${isBundleActive
//                                 ? "bg-primary text-white hover:bg-secondary hover:shadow-md active:scale-95 cursor-pointer"
//                                 : "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed opacity-60"
//                               }
//                             `}
//                           >
//                             {isBundleActive ? "Select Bundle" : "Draft (Disabled)"}
//                           </button>
                          
//                           <button 
//                             onClick={() => setExpandedCardId(isExpanded ? null : bundle._id)}
//                             className="p-2 hover:bg-secondary rounded-md text-gray-400 hover:text-white transition-all border"
//                           >
//                             {isExpanded ? <ChevronUp size={16} strokeWidth={2} /> : <ChevronDown size={16} strokeWidth={2} />}
//                           </button>
//                         </div>
//                       </div>
//                     </div>

//                     {isExpanded && (
//                       <div className="space-y-3 pt-3 border-t border-gray-100 animate-in fade-in slide-in-from-top-2 duration-300">
//                         <div className="text-[10px] font-bold text-gray-400 uppercase tracking-wider pb-1 text-left">
//                           KRA Configuration Details
//                         </div>
                        
//                         <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
//                           {bundle.kras?.map((item, idx) => {
//                             const kra = item.kraId;
//                             return (
//                               <div 
//                                 key={idx} 
//                                 className="bg-gray-50/70 border border-gray-100 rounded-md p-4 flex flex-col justify-between gap-3 shadow-sm hover:shadow transition-shadow duration-200"
//                               >
//                                 <div className="space-y-1 text-left">
//                                   <div className="flex items-center justify-between gap-2">
//                                     <div className="flex items-center gap-1.5 min-w-0">
//                                       <span className="flex h-5 w-5 items-center justify-center rounded-lg bg-gray-100 text-gray-500 font-bold text-[9px] shrink-0">
//                                         {String(idx + 1).padStart(2, "0")}
//                                       </span>
//                                       <p className="text-xs font-bold text-gray-800 truncate">
//                                         {kra?.name || "KRA Item"}
//                                       </p>
//                                     </div>

//                                     {kra?.category && (
//                                       <span className="text-[8px] bg-red-100 text-primary font-bold px-1.5 py-0.5 rounded uppercase shrink-0">
//                                         {kra.category}
//                                       </span>
//                                     )}
//                                   </div>

//                                   <p className="text-[11px] text-gray-400 line-clamp-2 leading-relaxed">
//                                     {kra?.description}
//                                   </p>
//                                 </div>

//                                 <div className="pt-2 border-t border-gray-200/60 space-y-1.5 text-left">
//                                   <div className="flex justify-between items-center text-[10px]">
//                                     <span className="text-gray-400 font-medium">Weightage allocation</span>
//                                     <span className="font-bold text-primary">{item.weightage}%</span>
//                                   </div>
//                                   <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden">
//                                     <div 
//                                       className="bg-primary h-full rounded-full" 
//                                       style={{ width: `${item.weightage}%` }} 
//                                     />
//                                   </div>
//                                 </div>
//                               </div>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 );
//               })
//             ) : (
//               filteredTemplates.map((template) => {
//                 // Check if already added to workspace list (Added)
//                 const isAlreadyAdded = selectedKras.some(k => k.kraId === template._id);
                
//                 return (
//                   <div key={template._id} className="bg-white border border-gray-200 rounded-xl p-5 hover:border-primary transition-all shadow-sm flex justify-between items-center text-left">
//                     <div>
//                       <span className="font-bold text-gray-900 text-sm">{template.name}</span>
//                       <p
//                         style={{
//                           display: "-webkit-box",
//                           WebkitLineClamp: 5,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                         }}
//                         className="text-[10px] text-gray-400 max-w-lg mt-1"
//                       >
//                         {template.description}
//                       </p>
//                     </div>
                    
//                     {/* Toggle Button / Badge based on added state */}
//                     {isAlreadyAdded ? (
//                       <span className="px-3 py-1.5 bg-green-50 text-green-700 border border-green-200 rounded-lg text-xs font-bold uppercase select-none shrink-0 ml-4">
//                         Added
//                       </span>
//                     ) : (
//                       <button 
//                         onClick={() => handleAddCustomKra(template)}
//                         className="bg-primary text-white text-xs font-bold px-4 py-1.5 rounded-lg hover:bg-secondary hover:shadow-md transition-all shrink-0 ml-4"
//                       >
//                         Add to Custom
//                       </button>
//                     )}
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* RIGHT PANEL: SELECTED DATA & CONFIGURATIONS */}
//         <div className="space-y-6">
//           <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-4">
//             <div className="flex justify-between items-center border-b pb-2">
//               <span className="font-bold text-gray-800 text-sm">Selected Employee / Team</span>
//               {selectedEmployees.length > 0 && (
//                 <button 
//                   onClick={() => setSelectedEmployees([])} 
//                   className="text-[10px] text-red-600 hover:text-red-700 hover:underline font-bold uppercase transition-all"
//                 >
//                   Undo all
//                 </button>
//               )}
//             </div>

//             {selectedEmployees.length === 0 ? (
//               <p className="text-center py-6 text-xs text-gray-400">No employees selected in filter.</p>
//             ) : (
//               <div className="space-y-3 max-h-[220px] overflow-y-auto pr-1">
//                 {selectedEmployees.map((emp) => (
//                   <div key={emp._id} className="flex justify-between items-center p-2.5 bg-gray-50 border rounded-lg relative text-left">
//                     <div className="flex items-center min-w-0">
//                       {emp.profilePicture ? (
//                         <img src={emp.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
//                       ) : (
//                         <div className="w-8 h-8 rounded-full bg-primary hover:bg-secondary flex items-center justify-center text-white text-[10px] font-bold shrink-0">
//                           {emp.firstName?.[0]}{emp.lastName?.[0]}
//                         </div>
//                       )}
//                       <div className="ml-2.5 min-w-0">
//                         <p className="text-xs font-bold text-gray-900 truncate">{emp.firstName} {emp.lastName}</p>
//                         <p className="text-[10px] text-gray-400 truncate">{emp.email}</p>
//                       </div>
//                     </div>
//                     <button onClick={() => handleRemoveEmployee(emp._id)} className="text-gray-400 hover:text-red-600 p-1 rounded-lg shrink-0 transition-colors">
//                       <X className="w-4 h-4" />
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-4">
//             {/* Added: Distribute Weightage Equally & Clear All buttons inside Sidebar header */}
//             <div className="flex justify-between items-center border-b pb-2">
//               <span className="font-bold text-gray-800 text-sm">Allocated KRA Mappings</span>
//               {selectedKras.length > 0 && (
//                 <div className="flex gap-2">
//                   <button
//                     type="button"
//                     onClick={handleAutoSplitWeights}
//                     className="text-[10px] text-primary hover:text-secondary font-bold uppercase underline transition-colors focus:outline-none"
//                   >
//                     Distribute Equally
//                   </button>
//                   <span className="text-gray-300">|</span>
//                   <button
//                     type="button"
//                     onClick={() => setSelectedKras([])}
//                     className="text-[10px] text-red-600 hover:text-red-700 font-bold uppercase underline transition-colors focus:outline-none"
//                   >
//                     Clear All
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* Unified selectedKras mapped details */}
//             {selectedKras.length > 0 ? (
//               <div className="space-y-4 max-h-[450px] overflow-y-auto pr-1">
//                 {selectedKras.map((k, idx) => (
//                   <div key={k.kraId} className="bg-gray-50 border border-gray-100 rounded-lg p-4 space-y-3 text-left shadow-sm">
//                     <div className="flex justify-between items-start gap-2">
//                       <div className="min-w-0 flex-1">
//                         <p className="text-xs font-bold text-gray-900 truncate">{k.name}</p>
//                         <p className="text-[10px] text-gray-400 line-clamp-1 mt-0.5">{k.description}</p>
//                       </div>
//                       <button onClick={() => handleRemoveCustomKra(k.kraId)} className="text-gray-400 hover:text-red-600 p-1 transition-colors">
//                         <X className="w-4 h-4" />
//                       </button>
//                     </div>

//                     {/* Weightage, Review Frequency and optional Target overrides added inside Sidebar configuration (Modern Styled Inputs) */}
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2.5 border-t border-gray-200/50">
//                       <div>
//                         <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Weightage *</label>
//                         <div className="flex items-center gap-1.5">
//                           <input 
//                             type="number" 
//                             value={k.weightage || ""}
//                             onChange={(e) => handleItemChange(idx, "weightage", Number(e.target.value) || 0)}
//                             className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-center text-xs font-bold outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] bg-white shadow-sm"
//                             min={0}
//                             max={100}
//                           />
//                           <span className="text-xs text-gray-400 font-bold">%</span>
//                         </div>
//                       </div>
                      
//                       <div>
//                         <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Review Frequency *</label>
//                         <div className="relative">
//                           <select
//                             value={k.reviewCycle}
//                             onChange={(e) => handleItemChange(idx, "reviewCycle", e.target.value)}
//                             className="w-full border border-gray-200 rounded-lg pl-2 pr-5 py-1 text-xs font-bold h-[28px] bg-white outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all shadow-sm appearance-none cursor-pointer"
//                           >
//                             <option value="1_MONTH">Monthly</option>
//                             <option value="2_MONTHS">2 Months</option>
//                             <option value="3_MONTHS">Quarterly</option>
//                             <option value="6_MONTHS">Half-Year</option>
//                             <option value="12_MONTHS">Annual</option>
//                           </select>
//                           <ChevronDown className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none stroke-[3]" />
//                         </div>
//                       </div>

//                       <div>
//                         <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Monthly Target (Optional)</label>
//                         <input 
//                           type="text" 
//                           value={k.monthlyTarget || ""}
//                           onChange={(e) => handleItemChange(idx, "monthlyTarget", e.target.value)}
//                           placeholder="e.g. ₹5 Lakhs"
//                           className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-xs outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] shadow-sm"
//                         />
//                       </div>

//                       <div>
//                         <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Yearly Target (Optional)</label>
//                         <input 
//                           type="text" 
//                           value={k.yearlyTarget || ""}
//                           onChange={(e) => handleItemChange(idx, "yearlyTarget", e.target.value)}
//                           placeholder="e.g. ₹60 Lakhs"
//                           className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-xs outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] shadow-sm"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//                 <div className="pt-2 space-y-2 border-t">
//                   <div className="flex justify-between items-center text-[10px] font-bold">
//                     <span className={totalCalculatedWeight === 100 ? "text-green-600" : "text-primary"}>
//                       Weightage Total: {totalCalculatedWeight}%
//                     </span>
//                     <span className="text-gray-400 uppercase tracking-wide text-[9px]">Strict Target: 100%</span>
//                   </div>
//                   <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden">
//                     <div className={`h-full rounded-full transition-all duration-300 ${totalCalculatedWeight === 100 ? "bg-green-500" : "bg-primary"}`} style={{ width: `${Math.min(100, totalCalculatedWeight)}%` }} />
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <p className="text-center py-6 text-xs text-gray-400">No goals or bundles chosen from left workspace.</p>
//             )}

//             <button 
//               onClick={handleConfirmAllocationTrigger}
//               disabled={submitting}
//               className="w-full bg-primary hover:bg-secondary text-white font-bold py-3 rounded-lg text-xs uppercase hover:shadow-lg transition-all"
//             >
//               {submitting ? "Processing..." : "Confirm Allocation"}
//             </button>
//           </div>
//         </div>
//       </div>

//     </div>
//       {/* CONFIRMATION DIALOG MODAL */}
//       {showConfirmModal && (
//         <div className="fixed inset-0 top-[57px] md:top-[65px] z-[75] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity">
//           <div className="bg-white w-full max-w-md rounded-xl shadow-xl border overflow-hidden p-6 space-y-4 animate-in fade-in zoom-in-95 duration-200">
//             <div className="flex items-start gap-3">
//               <div className="p-3 bg-red-50 text-red-600 rounded-full shrink-0">
//                 <AlertTriangle className="w-6 h-6" />
//               </div>
//               <div className="text-left">
//                 <h3 className="font-bold text-gray-900 text-base">Confirm KRA Allocation?</h3>
//                 <p className="text-xs text-red-600 font-semibold mt-1.5 leading-relaxed">
//                   Important: Combined Weightage is verified as exactly 100%. Once assigned, these parameters will trigger the active review appraisal cycle.
//                 </p>
//               </div>
//             </div>

//             {/* Selected Configuration Summary for validation */}
//             <div className="bg-gray-50 border rounded-lg p-3 text-[11px] space-y-1.5 text-gray-600 text-left">
//               <div className="flex justify-between"><span className="font-bold">Total Employees:</span> <span>{selectedEmployees.length} employee(s)</span></div>
//               <div className="flex justify-between"><span className="font-bold">Target Year:</span> <span>FY {year}</span></div>
//               <div className="flex justify-between"><span className="font-bold">Cycle Period:</span> <span>{startDate} to {endDate}</span></div>
//               <div className="flex justify-between"><span className="font-bold">KRA Count:</span> <span className="font-semibold text-primary">{selectedKras.length} items mapped</span></div>
//             </div>

//             <div className="flex items-center justify-end gap-3 pt-2">
//               <button 
//                 onClick={() => setShowConfirmModal(false)}
//                 className="px-4 py-2 text-xs font-bold rounded-lg border border-red-200 text-red-600 hover:bg-red-50 transition-colors uppercase tracking-wider"
//               >
//                 No, Go Back
//               </button>
//               <button 
//                 onClick={handleFinalSubmit}
//                 className="px-4 py-2 text-xs font-bold rounded-lg bg-primary text-white hover:bg-secondary hover:shadow-md transition-all uppercase tracking-wider"
//               >
//                 Yes, Allocate
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useState, useEffect, useMemo, useCallback } from "react";
import { CheckCircle2, ChevronDown, ChevronUp, X, Mail, AlertTriangle, Search } from "lucide-react"; 
import { toast } from "react-toastify";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";
import SelectDropdown from "../../customStyles/SelectDropdown";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../ui/PageHeader";
import CustomDatePicker from "../../customStyles/CustomDatePicker"; 
import { formatDateTime } from "../../helpers/formatDateTime";

// Helper to format system DB cycle keys to user-friendly labels
const formatCycleDisplay = (cycle) => {
  const mapping = {
    "1_WEEK": "Weekly",
    "2_WEEKS": "Bi-weekly",
    "1_MONTH": "Monthly",
    "2_MONTHS": "Bi-monthly",
    "3_MONTHS": "Quarterly",
    "6_MONTHS": "Half-Yearly",
    "12_MONTHS": "Annual"
  };
  return mapping[cycle] || cycle;
};

export default function TagKra() {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false); 
  const [successData, setSuccessData] = useState(null); 
  const [showConfirmModal, setShowConfirmModal] = useState(false); 
  const navigate = useNavigate();
  const { portalName } = useParams();

  // Dependency lists from backend
  const [usersList, setUsersList] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [bundlesList, setBundlesList] = useState([]);
  const [templatesList, setTemplatesList] = useState([]);
  const [workflowsList, setWorkflowsList] = useState([]);

  // Filters & Workspace selection states
  const [filterBy, setFilterBy] = useState("employee"); 
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [activeSourceTab, setActiveSourceTab] = useState("bundles"); 

  // Master lists search states
  const [bundleSearchTerm, setBundleSearchTerm] = useState("");
  const [templateSearchTerm, setTemplateSearchTerm] = useState("");

  // Current active selections in Workspace
  const [selectedEmployees, setSelectedEmployees] = useState([]); 
  const [selectedBundleId, setSelectedBundleId] = useState(""); 
  const [selectedKras, setSelectedKras] = useState([]); 

  // Allocation Meta Parameters
  const [year, setYear] = useState(2026);
  const [startDate, setStartDate] = useState("2026-04-01");
  const [endDate, setEndDate] = useState("2027-03-31");
  const [reviewCycle, setReviewCycle] = useState("3_MONTHS"); 
  const [workflowId, setWorkflowId] = useState("");

  const [expandedCardId, setExpandedCardId] = useState(null); 

  // ADDED: Handles dynamic financial year dates calculation upon target year change
  const handleYearChange = (val) => {
    const parsedYear = Number(val) || new Date().getFullYear();
    setYear(parsedYear);
    
    setStartDate(`${parsedYear}-04-01`);
    setEndDate(`${parsedYear + 1}-03-31`);
  };

  const loadWorkspaceDependencies = useCallback(async () => {
    setLoading(true);
    try {
      const [usersRes, deptRes, desRes, bundlesRes, templatesRes, workflowsRes] = await Promise.all([
        api.get(SummaryApi.getAllUsers.url),
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllDesignations?.url || "/api/hr/designations"),
        api.get(SummaryApi.getAllKraBundles?.url || "/api/hr/kras/bundles"),
        api.get(SummaryApi.getAllKraTemplates?.url || "/api/hr/kras/templates"),
        api.get(SummaryApi.getAllKRAReviewWorkflows?.url || "/api/hr/performance/workflows")
      ]);

      if (usersRes.data.success) setUsersList(usersRes.data.data || []);
      if (deptRes.data.success) setDepartments(deptRes.data.data || []);
      if (desRes.data.success) setDesignations(desRes.data.data || []);
      if (bundlesRes.data.success) setBundlesList(bundlesRes.data.data || []);
      if (templatesRes.data.success) setTemplatesList(templatesRes.data.data || []);
      if (workflowsRes.data.success) setWorkflowsList(workflowsRes.data.data || []);
    } catch {
      toast.error("Failed to load dependency data for goal tagging.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadWorkspaceDependencies();
  }, [loadWorkspaceDependencies]);

  const getCleanId = (field) => {
    if (!field) return "";
    return typeof field === "object" ? (field._id || "").toString() : field.toString();
  };

  useEffect(() => {
    if (filterBy === "designation") {
      if (!selectedDesignation && !selectedDepartment) {
        setSelectedEmployees([]);
        return;
      }

      const matchedUsers = usersList.filter(u => {
        const uDesigId = getCleanId(u.designationId);
        const uDeptId = getCleanId(u.departmentId);

        const matchDesig = selectedDesignation ? (uDesigId === selectedDesignation) : true;
        const matchDept = selectedDepartment ? (uDeptId === selectedDepartment) : true;

        return matchDesig && matchDept && u.isActive !== false;
      });

      setSelectedEmployees(matchedUsers);
    }
  }, [filterBy, selectedDesignation, selectedDepartment, usersList]);

  // Dropdown options formatting
  const designationOptions = useMemo(() => designations.map(d => ({ label: d.title, value: d._id })), [designations]);
  const departmentOptions = useMemo(() => departments.map(d => ({ label: d.name, value: d._id })), [departments]);
  const workflowOptions = useMemo(() => workflowsList.map(w => ({ label: w.name, value: w._id })), [workflowsList]);
  const employeeDropdownOptions = useMemo(() => {
    return usersList
      .filter(u => u.isActive !== false)
      .map(u => ({ label: `${u.firstName} ${u.lastName} - ${u.userId}`, value: u._id, raw: u }));
  }, [usersList]);

  const filteredBundles = useMemo(() => {
    return bundlesList.filter(b => {
      const query = bundleSearchTerm.toLowerCase();
      return (
        b.name?.toLowerCase().includes(query) ||
        b.description?.toLowerCase().includes(query) ||
        b.year?.toString().includes(query)
      );
    });
  }, [bundlesList, bundleSearchTerm]);

  const filteredTemplates = useMemo(() => {
    return templatesList.filter(t => {
      const query = templateSearchTerm.toLowerCase();
      return (
        t.name?.toLowerCase().includes(query) ||
        t.description?.toLowerCase().includes(query) ||
        t.category?.toLowerCase().includes(query)
      );
    });
  }, [templatesList, templateSearchTerm]);

  const handleSelectEmployeeDirect = (empId) => {
    const matchedUser = usersList.find(u => u._id === empId);
    if (matchedUser && !selectedEmployees.some(e => e._id === empId)) {
      setSelectedEmployees(prev => [...prev, matchedUser]);
    }
  };

  const handleRemoveEmployee = (empId) => {
    setSelectedEmployees(prev => prev.filter(e => e._id !== empId));
  };

  const handleDesignationSelect = (desigId) => {
    setSelectedDesignation(desigId);
    if (!desigId) {
      setSelectedEmployees([]);
      return;
    }
    const matchedUsers = usersList.filter(u => u.designationId?._id === desigId && u.isActive !== false);
    setSelectedEmployees(matchedUsers);
  };

  const handleSelectBundle = (bundle) => {
    setSelectedBundleId(bundle._id);
    setReviewCycle(bundle.reviewCycle); 
    const mapped = bundle.kras?.map(k => ({
      kraId: k.kraId?._id || k.kraId,
      name: k.kraId?.name || k.name || "Goal Metric",
      description: k.kraId?.description || k.description || "",
      category: k.kraId?.category || k.category || "Technical",
      weightage: k.weightage || 0,
      reviewCycle: k.reviewCycle || bundle.reviewCycle || "3_MONTHS",
      targetValue: k.targetValue || k.kraId?.targetValue || "", 
      metricType: k.metricType || k.kraId?.metricType || "HIGHER_IS_BETTER", // ✅ Synchronized metricType
      monthlyTarget: k.monthlyTarget || k.kraId?.monthlyTarget || "",
      yearlyTarget: k.yearlyTarget || k.kraId?.yearlyTarget || ""
    })) || [];
    setSelectedKras(mapped);
    toast.success(`${bundle.name} details imported into assignment workspace.`);
  };

  const handleAddCustomKra = (template) => {
    if (selectedKras.some(k => k.kraId === template._id)) return;
    setSelectedKras(prev => [
      ...prev,
      {
        kraId: template._id,
        name: template.name,
        description: template.description,
        category: template.category || "Technical",
        weightage: 0,
        reviewCycle: template.reviewCycle || reviewCycle || "3_MONTHS",
        targetValue: template.targetValue || "", 
        metricType: template.metricType || "HIGHER_IS_BETTER", // ✅ Added metricType selection
        monthlyTarget: template.monthlyTarget || "",
        yearlyTarget: template.yearlyTarget || ""
      }
    ]);
  };

  const handleRemoveCustomKra = (kraId) => {
    setSelectedKras(prev => prev.filter(k => k.kraId !== kraId));
  };

  const handleItemChange = (index, key, val) => {
    const updated = selectedKras.map((k, idx) => 
      idx === index ? { ...k, [key]: val } : k
    );
    setSelectedKras(updated);
  };

  const handleAutoSplitWeights = () => {
    const totalKras = selectedKras.length;
    if (totalKras === 0) return;

    const baseWeight = Math.floor(100 / totalKras);
    const remainder = 100 % totalKras;

    const updated = selectedKras.map((k, idx) => {
      const weight = idx < remainder ? baseWeight + 1 : baseWeight;
      return { ...k, weightage: weight };
    });

    setSelectedKras(updated);
    toast.info("Weights distributed equally across all allocated KRA mappings.");
  };

  const totalCalculatedWeight = useMemo(() => {
    return selectedKras.reduce((sum, k) => sum + Number(k.weightage), 0);
  }, [selectedKras]);

  const handleConfirmAllocationTrigger = () => {
    if (selectedEmployees.length === 0) return toast.error("Please select at least one employee.");
    if (!startDate || !endDate) return toast.error("Goal timeline boundary dates are required.");
    if (!workflowId) return toast.error("Please assign a review process workflow.");
    if (selectedKras.length === 0) return toast.error("Please add at least one KRA to allocate.");

    if (totalCalculatedWeight !== 100) {
      return toast.error(`Total assigned weightage must sum up to exactly 100%. Current total: ${totalCalculatedWeight}%.`);
    }

    setShowConfirmModal(true); 
  };

  const handleFinalSubmit = async () => {
    setShowConfirmModal(false);
    setSubmitting(true);

    const payload = {
      userIds: selectedEmployees.map(e => e._id),
      year,
      startDate: new Date(startDate).toISOString(),
      endDate: new Date(endDate).toISOString(),
      workflowId,
      reviewCycle, 
      bundleId: selectedBundleId || undefined,
      krasInput: selectedKras.map(k => ({
        kraId: k.kraId,
        weightage: k.weightage,
        reviewCycle: k.reviewCycle,
        targetValue: k.targetValue || undefined, 
        metricType: k.metricType || "HIGHER_IS_BETTER", // ✅ Added metricType payload
        monthlyTarget: k.monthlyTarget || undefined,
        yearlyTarget: k.yearlyTarget || undefined
      }))
    };

    try {
      const res = await api.post(SummaryApi.assignKra?.url || "/api/hr/kra/assign", payload);
      if (res.data.success) {
        setSuccessData(res.data.data); 
        toast.success("Goals successfully allocated!");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to process goal allocation.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleResetWorkspace = () => {
    setSelectedEmployees([]);
    setSelectedBundleId("");
    setSelectedKras([]);
    setSuccessData(null);
  };

  const getDynamicUserDetails = useMemo(() => {
    if (!successData || successData.length === 0) return { departments: "N/A", designations: "N/A" };
    
    const matchedDepts = [];
    const matchedDesigs = [];

    successData.forEach(assign => {
      const fullUser = usersList.find(u => u._id === (assign.userId?._id || assign.userId));
      if (fullUser) {
        const dept = fullUser.departmentId?.name || "N/A";
        const desig = fullUser.designationId?.title || fullUser.designationId?.name || "N/A";
        if (!matchedDepts.includes(dept)) matchedDepts.push(dept);
        if (!matchedDesigs.includes(desig)) matchedDesigs.push(desig);
      }
    });

    return {
      departments: matchedDepts.join(", ") || "N/A",
      designations: matchedDesigs.join(", ") || "N/A"
    };
  }, [successData, usersList]);

  if (loading) return <PageLoader />;

  // DYNAMIC SUCCESS SUMMARY VIEW
  if (successData && successData.length > 0) {
    const firstItem = successData[0];
    const employeeNames = successData.map(item => {
      const fullUser = usersList.find(u => u._id === (item.userId?._id || item.userId));
      return fullUser ? `${fullUser.firstName} ${fullUser.lastName}` : "Employee";
    }).join(", ");
    
    const allocatedBy = firstItem.assignedBy ? `${firstItem.assignedBy.firstName} ${firstItem.assignedBy.lastName}` : "Sarah Jenkins (HRM)";
    const allocationDate = firstItem.createdAt ? new Date(firstItem.createdAt).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : new Date().toLocaleDateString();

    return (
      <div className="space-y-6 animate-scale-in p-2">
        <div className="text-center space-y-3">
          <div className="w-16 h-16 bg-blue-50 border-2 border-blue-200 rounded-full flex items-center justify-center mx-auto text-blue-600">
            <CheckCircle2 className="w-8 h-8" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 leading-tight">KRA Successfully Allocated</h2>
          <p className="text-xs text-gray-400 max-w-lg mx-auto">
            The Key Result Areas have been successfully assigned to the employee(s) for the current review cycle. Notifications have been sent.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 space-y-6">
            <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
              <div className="flex justify-between border-b pb-2">
                <span className="font-bold text-gray-800 text-sm">Allocation Summary</span>
                <span className="text-[10px] bg-green-50 text-green-700 font-bold px-2 py-0.5 rounded-full uppercase border border-green-200">Active Cycle</span>
              </div>
              
              <div className="grid grid-cols-2 gap-y-4 gap-x-2 text-xs">
                <div>
                  <p className="text-gray-400 font-medium">Employee(s)</p>
                  <p className="font-bold text-gray-900 mt-1">{employeeNames}</p>
                </div>
                <div>
                  <p className="text-gray-400 font-medium">Department(s)</p>
                  <p className="font-bold text-gray-900 mt-1">{getDynamicUserDetails.departments}</p>
                </div>
                <div>
                  <p className="text-gray-400 font-medium">Designation(s)</p>
                  <p className="font-bold text-gray-900 mt-1">{getDynamicUserDetails.designations}</p>
                </div>
                <div>
                  <p className="text-gray-400 font-medium">Review Frequency & Workflow</p>
                  <p className="font-bold text-gray-900 mt-1 truncate max-w-xs" title={firstItem.workflowId?.name}>
                    {firstItem.workflowId?.name || "Standard Workflow"} ({formatCycleDisplay(firstItem.reviewCycle)})
                  </p>
                </div>
                <div>
                  <p className="text-gray-400 font-medium">Allocation Date</p>
                  <p className="font-bold text-gray-900 mt-1">{allocationDate}</p>
                </div>
                <div>
                  <p className="text-gray-400 font-medium">Allocated By</p>
                  <p className="font-bold text-gray-900 mt-1">{allocatedBy}</p>
                </div>
              </div>
            </div>

            {/* Dynamic KRA List Visualizer */}
            <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
              <span className="font-bold text-gray-800 text-sm border-b pb-2 block">Assigned Goals ({firstItem.kras?.length || 0} items)</span>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-[350px] overflow-y-auto pr-1">
                {firstItem.kras?.map((kra, index) => (
                  <div key={index} className="p-3 bg-gray-50 border rounded-lg space-y-1.5 text-left">
                    <div className="flex justify-between items-start gap-2">
                      <span className="text-xs font-bold text-gray-800 truncate" title={kra.name}>{kra.name}</span>
                      <span className="text-[9px] bg-red-100 text-red-600 font-bold px-1.5 py-0.5 rounded uppercase shrink-0">{kra.category}</span>
                    </div>
                    <p className="text-[10px] text-gray-400 line-clamp-2 leading-relaxed">{kra.description || "No description provided."}</p>
                    
                    {/* Visual Target details in Success screen */}
                    <div className="text-[9px] text-gray-500 font-medium border-t pt-1 space-y-0.5">
                      <div className="flex justify-between">
                        <span>Cycle:</span> <span className="font-bold">{formatCycleDisplay(kra.reviewCycle)}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Target Value:</span> <span className="font-extrabold text-gray-800">{kra.targetValue || "N/A"}</span>
                      </div>
                      {/* ✅ Added metricType view on Success Screen */}
                      <div className="flex justify-between">
                        <span>Goal Direction:</span> <span className="font-extrabold text-gray-800">{kra.metricType === "LOWER_IS_BETTER" ? "Lower is Better" : "Higher is Better"}</span>
                      </div>
                    </div>

                    <div className="pt-1 flex justify-between items-center text-[10px]">
                      <span className="text-gray-400">Weightage</span>
                      <span className="font-bold text-primary">{kra.weightage}%</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white border rounded-lg p-6 space-y-3 shadow-sm flex flex-col">
              <button onClick={handleResetWorkspace} className="w-full bg-primary hover:bg-secondary text-white py-3 rounded-lg font-bold text-xs uppercase hover:shadow-lg transition-all">
                Allocate Another
              </button>
              <button onClick={() => navigate(`/${portalName}/hr/performance-management?tab=tag_kra_list`)} className="w-full bg-white border border-gray-200 text-gray-600 hover:bg-gray-100 py-3 rounded-lg font-bold text-xs uppercase transition-all">
                Go to Dashboard
              </button>
            </div>

            <div className="bg-white border rounded-lg p-6 shadow-sm space-y-4">
              <div className="flex items-center gap-2 text-xs font-bold text-gray-700">
                <Mail className="w-4 h-4 text-gray-400" />
                <span>Notification Sent Preview</span>
              </div>
              <div className="bg-gray-50 border p-4 rounded-xl text-[11px] space-y-2">
                <p className="font-bold text-gray-800">To: <span className="text-gray-500 font-normal">{firstItem.userId?.email || "Employee"}</span></p>
                <p className="font-bold text-gray-800">Subject: New KRA Assigned - FY {firstItem.year}</p>
                <p className="text-gray-500 leading-relaxed">
                  Goals and Key Result Areas for the year {firstItem.year} have been successfully assigned. Please log in to your performance portal to acknowledge and accept them.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="space-y-6 animate-in fade-in duration-300">
      <PageHeader
        title="Tag KRA"
        description=""
        isSticky={true}
        topOffset="top-[51px]"
        onBack={() => navigate(-1)}
      />

      {/* Filter panel */}
      <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
          <div>
            <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Filter By *</span>
            <div className="flex items-center gap-6 h-10">
              <label className="flex items-center gap-2.5 text-xs font-bold text-gray-700 cursor-pointer">
                <input 
                  type="radio" 
                  checked={filterBy === "designation"}
                  onChange={() => { setFilterBy("designation"); handleDesignationSelect(""); }}
                  className="accent-primary h-4 w-4"
                />
                Designation
              </label>
              <label className="flex items-center gap-2.5 text-xs font-bold text-gray-700 cursor-pointer">
                <input 
                  type="radio" 
                  checked={filterBy === "employee"}
                  onChange={() => { setFilterBy("employee"); setSelectedEmployees([]); }}
                  className="accent-primary h-4 w-4"
                />
                Employee
              </label>
            </div>
          </div>

          {filterBy === "designation" ? (
            <div>
              <label className="block text-xs font-extrabold text-gray-500 uppercase tracking-wider mb-1.5">Designation *</label>
              <SelectDropdown 
                options={designationOptions}
                value={selectedDesignation}
                onChange={handleDesignationSelect}
                placeholder="Choose Designation..."
                valueKey="value"
                labelKey="label"
                searchable={true} 
                ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm"
              />
            </div>
          ) : (
            <div>
              <label className="block text-xs font-extrabold text-gray-500 uppercase tracking-wider mb-1.5">Select Employee *</label>
              <SelectDropdown 
                options={employeeDropdownOptions}
                onChange={handleSelectEmployeeDirect}
                placeholder="Search & choose employee..."
                searchable={true} 
                valueKey="value"
                labelKey="label"
                ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm"
              />
            </div>
          )}

          <div>
            <label className="block text-xs font-extrabold text-gray-500 uppercase tracking-wider mb-1.5">Department</label>
            <SelectDropdown options={departmentOptions} value={selectedDepartment} onChange={setSelectedDepartment} placeholder="All Departments" valueKey="value" labelKey="label" searchable={true} ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 pt-2">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Goal Start Date *</label>
            <CustomDatePicker 
              value={startDate} 
              onChange={setStartDate} 
              showCapacityInfo={false} 
              inputClassName="h-10 text-sm rounded-lg border-gray-200 focus:border-red-400 shadow-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Goal End Date *</label>
            <CustomDatePicker 
              value={endDate} 
              onChange={setEndDate} 
              showCapacityInfo={false} 
              inputClassName="h-10 text-sm rounded-lg border-gray-200 focus:border-red-400 shadow-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Goal Target Year *</label>
            <input 
              type="number" 
              value={year} 
              onChange={(e) => handleYearChange(e.target.value)} 
              className="w-full border border-gray-200 rounded-lg px-4 py-2 text-sm h-10 outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 shadow-sm transition-all" 
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Appraisal Workflow *</label>
            <SelectDropdown options={workflowOptions} value={workflowId} onChange={setWorkflowId} placeholder="Select Workflow" valueKey="value" labelKey="label" searchable={true} ChildClassName="h-10 border-gray-200 focus:border-red-400 focus:ring-1 focus:ring-red-100 rounded-lg shadow-sm" />
          </div>
        </div>
      </div>

      {/* WORKSPACE SPLIT GRID LAYOUT */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
        {/* LEFT PANEL */}
        <div className="lg:col-span-2 space-y-4">
          <div className="flex gap-4 border-b pb-2">
            <button 
              onClick={() => setActiveSourceTab("bundles")}
              className={`pb-2 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
                activeSourceTab === "bundles" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              Bundles ({filteredBundles.length})
            </button>
            <button 
              onClick={() => setActiveSourceTab("individual")}
              className={`pb-2 px-4 text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
                activeSourceTab === "individual" ? "border-primary text-primary" : "border-transparent text-gray-400 hover:text-gray-600"
              }`}
            >
              Individual KRAs ({filteredTemplates.length})
            </button>
          </div>

          {activeSourceTab === "bundles" ? (
            <div className="relative">
              <Search className="absolute left-3.5 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input 
                type="text" 
                placeholder="Search KRA bundles..." 
                value={bundleSearchTerm} 
                onChange={(e) => setBundleSearchTerm(e.target.value)} 
                className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg outline-none text-xs focus:border-red-400 focus:ring-1 focus:ring-red-100 shadow-sm transition-all bg-white"
              />
            </div>
          ) : (
            <div className="relative">
              <Search className="absolute left-3.5 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input 
                type="text" 
                placeholder="Search individual templates..." 
                value={templateSearchTerm} 
                onChange={(e) => setTemplateSearchTerm(e.target.value)} 
                className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg outline-none text-xs focus:border-red-400 focus:ring-1 focus:ring-red-100 shadow-sm transition-all bg-white"
              />
            </div>
          )}

          <div className="space-y-4">
            {activeSourceTab === "bundles" ? (
              filteredBundles.map((bundle) => {
                const isExpanded = expandedCardId === bundle._id;
                const totalBundleWeight = bundle.kras?.reduce((sum, item) => sum + (item.weightage || 0), 0) || 0;
                
                const deptName = bundle.departmentId?.name;
                const desigTitle = bundle.designationId?.title || bundle.designationId?.name;
                const divName = bundle.divisionId?.name;
                const orgMeta = [divName, deptName, desigTitle].filter(Boolean).join(" • ");
                const isBundleActive = bundle.status === "ACTIVE";

                return (
                  <div 
                    key={bundle._id} 
                    className={`bg-white border rounded-xl p-5 hover:shadow-md hover:border-primary transition-all duration-300 space-y-4 ${
                      isExpanded ? "border-2 border-secondary hover:border-primary" : "border-gray-200"
                    }`}
                  >
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                      <div className="space-y-1.5 min-w-0 flex-1 text-left">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="font-bold text-gray-900 text-sm sm:text-base leading-tight">
                            {bundle.name}
                          </span>
                          
                          <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${
                            bundle.status === "ACTIVE" 
                              ? "bg-green-50 text-green-700 border border-green-200" 
                              : "bg-gray-100 text-gray-500 border border-gray-200"
                          }`}>
                            {bundle.status}
                          </span>

                          <span className="text-[9px] bg-slate-50 text-slate-600 font-bold px-2 py-0.5 rounded-full border border-slate-200 uppercase tracking-wider">
                            FY {bundle.year}
                          </span>

                          <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider border ${
                            totalBundleWeight === 100
                              ? "bg-blue-50 text-blue-700 border-blue-200"
                              : "bg-amber-50 text-amber-700 border-amber-200"
                          }`}>
                            Weight: {totalBundleWeight}%
                          </span>
                        </div>

                        {orgMeta && (
                          <p className="text-[10px] text-primary font-bold uppercase tracking-wide">
                            {orgMeta}
                          </p>
                        )}

                        <p className="text-[10px] text-gray-400 font-medium">
                          Contains {bundle.kras?.length || 0} goals | Created on {formatDateTime ? formatDateTime(bundle.createdAt, false) : new Date(bundle.createdAt).toLocaleDateString()}
                        </p>
                      </div>

                      <div className="flex items-center gap-3 shrink-0 self-end md:self-center w-full md:w-auto justify-between md:justify-end border-t md:border-t-0 pt-3 md:pt-0">
                        <span className="md:hidden text-[10px] text-gray-400 font-bold uppercase tracking-wider">
                          Review Frequency: {formatCycleDisplay(bundle.reviewCycle)}
                        </span>
                        
                        <div className="flex items-center gap-2">
                          <button 
                            disabled={!isBundleActive} 
                            onClick={() => isBundleActive && handleSelectBundle(bundle)}
                            className={`
                              text-xs font-bold px-4 py-2 rounded-lg transition-all
                              ${isBundleActive
                                ? "bg-primary text-white hover:bg-secondary hover:shadow-md active:scale-95 cursor-pointer"
                                : "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed opacity-60"
                              }
                            `}
                          >
                            {isBundleActive ? "Select Bundle" : "Draft (Disabled)"}
                          </button>
                          
                          <button 
                            onClick={() => setExpandedCardId(isExpanded ? null : bundle._id)}
                            className="p-2 hover:bg-secondary rounded-md text-gray-400 hover:text-white transition-all border"
                          >
                            {isExpanded ? <ChevronUp size={16} strokeWidth={2} /> : <ChevronDown size={16} strokeWidth={2} />}
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Left side Expanded view */}
                    {isExpanded && (
                      <div className="space-y-3 pt-3 border-t border-gray-100 animate-in fade-in slide-in-from-top-2 duration-300">
                        <div className="text-[10px] font-bold text-gray-400 uppercase tracking-wider pb-1 text-left">
                          KRA Configuration Details
                        </div>
                        
                        <div className="grid grid-cols-1 2xl:grid-cols-2 gap-3">
                          {bundle.kras?.map((item, idx) => {
                            const kra = item.kraId;
                            return (
                              <div 
                                key={idx} 
                                className="bg-gray-50/70 border border-gray-100 rounded-md p-4 flex flex-col justify-between gap-3 shadow-sm hover:shadow transition-shadow duration-200"
                              >
                                <div className="space-y-1 text-left">
                                  <div className="flex items-center justify-between gap-2">
                                    <div className="flex items-center gap-1.5 min-w-0">
                                      <span className="flex h-5 w-5 items-center justify-center rounded-lg bg-gray-100 text-gray-500 font-bold text-[9px] shrink-0">
                                        {String(idx + 1).padStart(2, "0")}
                                      </span>
                                      <p className="text-xs font-bold text-gray-800 truncate">
                                        {kra?.name || "KRA Item"}
                                      </p>
                                    </div>

                                    {kra?.category && (
                                      <span className="text-[8px] bg-red-100 text-primary font-bold px-1.5 py-0.5 rounded uppercase shrink-0">
                                        {kra.category}
                                      </span>
                                    )}
                                  </div>

                                  <p className="text-[11px] text-gray-400 line-clamp-2 leading-relaxed">
                                    {kra?.description}
                                  </p>

                                  <div className="text-[10px] text-gray-500 pt-1 flex flex-wrap gap-2">
                                    <span>Cycle: <strong className="text-gray-700">{formatCycleDisplay(item.reviewCycle)}</strong></span>
                                    <span>•</span>
                                    <span>Target Value: <strong className="text-gray-700">{item.targetValue || kra?.targetValue || "N/A"}</strong></span>
                                    {/* ✅ Added metricType view in Left Expanded Bundle */}
                                    <span>•</span>
                                    <span>Direction: <strong className="text-gray-700">{item.metricType === "LOWER_IS_BETTER" ? "Lower is Better" : "Higher is Better"}</strong></span>
                                  </div>
                                </div>

                                <div className="pt-2 border-t border-gray-200/60 space-y-1.5 text-left">
                                  <div className="flex justify-between items-center text-[10px]">
                                    <span className="text-gray-400 font-medium">Weightage allocation</span>
                                    <span className="font-bold text-primary">{item.weightage}%</span>
                                  </div>
                                  <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden">
                                    <div 
                                      className="bg-primary h-full rounded-full" 
                                      style={{ width: `${item.weightage}%` }} 
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              filteredTemplates.map((template) => {
                const isAlreadyAdded = selectedKras.some(k => k.kraId === template._id);
                
                return (
                  <div key={template._id} className="bg-white border border-gray-200 rounded-xl p-5 hover:border-primary transition-all shadow-sm flex justify-between items-center text-left">
                    <div>
                      <span className="font-bold text-gray-900 text-sm">{template.name}</span>
                      <p
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 5,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                        className="text-[10px] text-gray-400 max-w-lg mt-1"
                      >
                        {template.description}
                      </p>
                      <div className="text-[10px] text-gray-500 mt-2 flex gap-3">
                        <span>Cycle: <strong className="text-gray-700">{formatCycleDisplay(template.reviewCycle)}</strong></span>
                        <span>•</span>
                        <span>Target: <strong className="text-gray-700">{template.targetValue || "N/A"}</strong></span>
                        {/* ✅ Added metricType display in standalone items */}
                        <span>•</span>
                        <span>Direction: <strong className="text-gray-700">{template.metricType === "LOWER_IS_BETTER" ? "Lower is Better" : "Higher is Better"}</strong></span>
                      </div>
                    </div>
                    
                    {isAlreadyAdded ? (
                      <span className="px-3 py-1.5 bg-green-50 text-green-700 border border-green-200 rounded-lg text-xs font-bold uppercase select-none shrink-0 ml-4">
                        Added
                      </span>
                    ) : (
                      <button 
                        onClick={() => handleAddCustomKra(template)}
                        className="bg-primary text-white text-xs font-bold px-4 py-1.5 rounded-lg hover:bg-secondary hover:shadow-md transition-all shrink-0 ml-4"
                      >
                        Add to Custom
                      </button>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* RIGHT PANEL: SELECTED DATA & CONFIGURATIONS */}
        <div className="space-y-6">
          <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-4">
            <div className="flex justify-between items-center border-b pb-2">
              <span className="font-bold text-gray-800 text-sm">Selected Employee / Team</span>
              {selectedEmployees.length > 0 && (
                <button 
                  onClick={() => setSelectedEmployees([])} 
                  className="text-[10px] text-red-600 hover:text-red-700 hover:underline font-bold uppercase transition-all"
                >
                  Undo all
                </button>
              )}
            </div>

            {selectedEmployees.length === 0 ? (
              <p className="text-center py-6 text-xs text-gray-400">No employees selected in filter.</p>
            ) : (
              <div className="space-y-3 max-h-[220px] overflow-y-auto pr-1">
                {selectedEmployees.map((emp) => (
                  <div key={emp._id} className="flex justify-between items-center p-2.5 bg-gray-50 border rounded-lg relative text-left">
                    <div className="flex items-center min-w-0">
                      {emp.profilePicture ? (
                        <img src={emp.profilePicture} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
                      ) : (
                        <div className="w-8 h-8 rounded-full bg-primary hover:bg-secondary flex items-center justify-center text-white text-[10px] font-bold shrink-0">
                          {emp.firstName?.[0]}{emp.lastName?.[0]}
                        </div>
                      )}
                      <div className="ml-2.5 min-w-0">
                        <p className="text-xs font-bold text-gray-900 truncate">{emp.firstName} {emp.lastName}</p>
                        <p className="text-[10px] text-gray-400 truncate">{emp.email}</p>
                      </div>
                    </div>
                    <button onClick={() => handleRemoveEmployee(emp._id)} className="text-gray-400 hover:text-red-600 p-1 rounded-lg shrink-0 transition-colors">
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-4">
            <div className="flex justify-between items-center border-b pb-2">
              <span className="font-bold text-gray-800 text-sm">Allocated KRA Mappings</span>
              {selectedKras.length > 0 && (
                <div className="flex gap-2">
                  <button
                    type="button"
                    onClick={handleAutoSplitWeights}
                    className="text-[10px] text-primary hover:text-secondary font-bold uppercase underline transition-colors focus:outline-none"
                  >
                    Distribute Equally
                  </button>
                  <span className="text-gray-300">|</span>
                  <button
                    type="button"
                    onClick={() => setSelectedKras([])}
                    className="text-[10px] text-red-600 hover:text-red-700 font-bold uppercase underline transition-colors focus:outline-none"
                  >
                    Clear All
                  </button>
                </div>
              )}
            </div>

            {selectedKras.length > 0 ? (
              <div className="space-y-4 max-h-[480px] overflow-y-auto pr-1">
                {selectedKras.map((k, idx) => (
                  <div key={k.kraId} className="bg-gray-50 border border-gray-100 rounded-lg p-4 space-y-3 text-left shadow-sm">
                    <div className="flex justify-between items-start gap-2">
                      <div className="min-w-0 flex-1">
                        <p className="text-xs font-bold text-gray-900 truncate">{k.name}</p>
                        <p className="text-[10px] text-gray-400 line-clamp-1 mt-0.5">{k.description}</p>
                      </div>
                      <button onClick={() => handleRemoveCustomKra(k.kraId)} className="text-gray-400 hover:text-red-600 p-1 transition-colors">
                        <X className="w-4 h-4" />
                      </button>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2.5 border-t border-gray-200/50">
                      <div>
                        <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Weightage *</label>
                        <div className="flex items-center gap-1.5">
                          <input 
                            type="number" 
                            value={k.weightage || ""}
                            onChange={(e) => handleItemChange(idx, "weightage", Number(e.target.value) || 0)}
                            className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-center text-xs font-bold outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] bg-white shadow-sm"
                            min={0}
                            max={100}
                          />
                          <span className="text-xs text-gray-400 font-bold">%</span>
                        </div>
                      </div>
                      
                      <div>
                        <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Review Frequency *</label>
                        <div className="relative">
                          <select
                            value={k.reviewCycle}
                            onChange={(e) => handleItemChange(idx, "reviewCycle", e.target.value)}
                            className="w-full border border-gray-200 rounded-lg pl-2 pr-5 py-1 text-xs font-bold h-[28px] bg-white outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all shadow-sm appearance-none cursor-pointer"
                          >
                            <option value="1_WEEK">Weekly</option>
                            <option value="2_WEEKS">Bi-weekly</option>
                            <option value="1_MONTH">Monthly</option>
                            <option value="2_MONTHS">2 Months</option>
                            <option value="3_MONTHS">Quarterly</option>
                            <option value="6_MONTHS">Half-Year</option>
                            <option value="12_MONTHS">Annual</option>
                          </select>
                          <ChevronDown className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none stroke-[3]" />
                        </div>
                      </div>

                      {/* Unified target value input field */}
                      <div className="sm:col-span-2">
                        <label className="block text-[9px] font-bold text-primary uppercase mb-1">Target Value *</label>
                        <input 
                          type="text" 
                          value={k.targetValue || ""}
                          onChange={(e) => handleItemChange(idx, "targetValue", e.target.value)}
                          placeholder="e.g. 25 APIs, 3 Modules"
                          className="w-full border border-red-200 rounded-lg px-2.5 py-1 text-xs outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] shadow-sm font-bold bg-white"
                        />
                      </div>

                      {/* ✅ Added Goal/Metric Direction Dropdown to support custom target value behavior */}
                      <div className="sm:col-span-2">
                        <label className="block text-[9px] font-bold text-gray-700 uppercase mb-1">Goal Direction *</label>
                        <div className="relative">
                          <select
                            value={k.metricType || "HIGHER_IS_BETTER"}
                            onChange={(e) => handleItemChange(idx, "metricType", e.target.value)}
                            className="w-full border border-gray-200 rounded-lg pl-2 pr-5 py-1 text-xs font-bold h-[28px] bg-white outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all shadow-sm appearance-none cursor-pointer"
                          >
                            <option value="HIGHER_IS_BETTER">Higher is Better (Direct)</option>
                            <option value="LOWER_IS_BETTER">Lower is Better (Inverse)</option>
                          </select>
                          <ChevronDown className="absolute right-1.5 top-1/2 -translate-y-1/2 h-3 w-3 text-gray-400 pointer-events-none stroke-[3]" />
                        </div>
                      </div>

                      <div>
                        <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Monthly Target (Legacy)</label>
                        <input 
                          type="text" 
                          value={k.monthlyTarget || ""}
                          onChange={(e) => handleItemChange(idx, "monthlyTarget", e.target.value)}
                          placeholder="e.g. ₹5 Lakhs"
                          className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-xs outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] shadow-sm"
                        />
                      </div>

                      <div>
                        <label className="block text-[9px] font-bold text-gray-400 uppercase mb-1">Yearly Target (Legacy)</label>
                        <input 
                          type="text" 
                          value={k.yearlyTarget || ""}
                          onChange={(e) => handleItemChange(idx, "yearlyTarget", e.target.value)}
                          placeholder="e.g. ₹60 Lakhs"
                          className="w-full border border-gray-200 rounded-lg px-2.5 py-1 text-xs outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 transition-all h-[28px] shadow-sm"
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <div className="pt-2 space-y-2 border-t">
                  <div className="flex justify-between items-center text-[10px] font-bold">
                    <span className={totalCalculatedWeight === 100 ? "text-green-600" : "text-primary"}>
                      Weightage Total: {totalCalculatedWeight}%
                    </span>
                    <span className="text-gray-400 uppercase tracking-wide text-[9px]">Strict Target: 100%</span>
                  </div>
                  <div className="w-full bg-gray-200 h-1.5 rounded-full overflow-hidden">
                    <div className={`h-full rounded-full transition-all duration-300 ${totalCalculatedWeight === 100 ? "bg-green-500" : "bg-primary"}`} style={{ width: `${Math.min(100, totalCalculatedWeight)}%` }} />
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-center py-6 text-xs text-gray-400">No goals or bundles chosen from left workspace.</p>
            )}

            <button 
              onClick={handleConfirmAllocationTrigger}
              disabled={submitting}
              className="w-full bg-primary hover:bg-secondary text-white font-bold py-3 rounded-lg text-xs uppercase hover:shadow-lg transition-all"
            >
              {submitting ? "Processing..." : "Confirm Allocation"}
            </button>
          </div>
        </div>
      </div>

    </div>
      {/* CONFIRMATION DIALOG MODAL */}
      {showConfirmModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[75] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity">
          <div className="bg-white w-full max-w-md rounded-xl shadow-xl border overflow-hidden p-6 space-y-4 animate-in fade-in zoom-in-95 duration-200">
            <div className="flex items-start gap-3">
              <div className="p-3 bg-red-50 text-red-600 rounded-full shrink-0">
                <AlertTriangle className="w-6 h-6" />
              </div>
              <div className="text-left">
                <h3 className="font-bold text-gray-900 text-base">Confirm KRA Allocation?</h3>
                <p className="text-xs text-red-600 font-semibold mt-1.5 leading-relaxed">
                  Important: Combined Weightage is verified as exactly 100%. Once assigned, these parameters will trigger the active review appraisal cycle.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 border rounded-lg p-3 text-[11px] space-y-1.5 text-gray-600 text-left">
              <div className="flex justify-between"><span className="font-bold">Total Employees:</span> <span>{selectedEmployees.length} employee(s)</span></div>
              <div className="flex justify-between"><span className="font-bold">Target Year:</span> <span>FY {year}</span></div>
              <div className="flex justify-between"><span className="font-bold">Cycle Period:</span> <span>{startDate} to {endDate}</span></div>
              <div className="flex justify-between"><span className="font-bold">KRA Count:</span> <span className="font-semibold text-primary">{selectedKras.length} items mapped</span></div>
            </div>

            <div className="flex items-center justify-end gap-3 pt-2">
              <button 
                onClick={() => setShowConfirmModal(false)}
                className="px-4 py-2 text-xs font-bold rounded-lg border border-red-200 text-red-600 hover:bg-red-50 transition-colors uppercase tracking-wider"
              >
                No, Go Back
              </button>
              <button 
                onClick={handleFinalSubmit}
                className="px-4 py-2 text-xs font-bold rounded-lg bg-primary text-white hover:bg-secondary hover:shadow-md transition-all uppercase tracking-wider"
              >
                Yes, Allocate
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}